import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  constructor() {
}

/**
 * Register the Service Worker Thread
 * */
// registerServiceWorker() {
//     if ('serviceWorker' in navigator) {
//         window.addEventListener('load', function () {
//             navigator.serviceWorker.register('/ngsw-worker.js').then(function (registration) {
//             }, function (err) {
//                 console.log('ServiceWorker registration failed: ', err);
//             }).finally(
//             );
//         });
//     }
// }

  title = 'mydocma-pt-app';
}
